import { useLayoutEffect, useRef } from 'react';

import useDeferInviteNotifications from './useDeferInviteNotifications';

/**
 * Keeps a fresh defer flag for Matrix event handlers (avoids stale `isDeferred` closure
 * between route change and useEffect listener rebind). Clears visible invite UI
 * synchronously when entering a deferred zone so toasts never paint during a call (#8150).
 */
const useDeferredInviteGate = (clearDeferredUi: () => void) => {
  const isDeferred = useDeferInviteNotifications();
  const isDeferredRef = useRef(isDeferred);
  isDeferredRef.current = isDeferred;

  useLayoutEffect(() => {
    if (isDeferred) clearDeferredUi();
  }, [isDeferred, clearDeferredUi]);

  return { isDeferred, isDeferredRef };
};

export default useDeferredInviteGate;
